import { render, staticRenderFns } from "./integralRuleFees.vue?vue&type=template&id=2a94f91e&scoped=true"
import script from "./integralRuleFees.vue?vue&type=script&lang=js"
export * from "./integralRuleFees.vue?vue&type=script&lang=js"
import style0 from "./integralRuleFees.vue?vue&type=style&index=0&id=2a94f91e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94f91e",
  null
  
)

export default component.exports